import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./styles.module.css";
import Loading from "../../app/layout/Loading";
import { Segment } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import NotFound from "../errors/NotFound";
import Modal from "../../app/common/modals/Custom";
import { ReactComponent as SuccessSvg } from "../../assets/success.svg";
import { ReactComponent as FailureSvg } from "../../assets/failure.svg";
import { observer } from "mobx-react-lite";

const CallbackPage = () => {
  const [searchParams] = useSearchParams();
  const [countDown] = useState(true);
  const [onPageLoad, setOnPageLoad] = useState("");
  const [val, setVal] = useState("");
  const { userStore, commonStore } = useStore();
  const { getCallBackResponse } = commonStore;

  const checkParams = async () => {
    var encodedString = searchParams.get("request");
    // console.log(encodedString);

    try {
      if (encodedString) {
        const response = await getCallBackResponse(encodedString);
        if (response.isSuccessful) {
          setOnPageLoad("success");
        } else setOnPageLoad("failure");
        // setOnPageLoad("failure");
      } else
        setTimeout(() => {
          setOnPageLoad("error");
        }, 4000);
    } catch (error) {
      setTimeout(() => {
        setOnPageLoad("error");
      }, 4000);
    }
  };
  useEffect(() => {
    if (onPageLoad !== "loading") {
      setOnPageLoad("loading");
      // console.log(onPageLoad);
      checkParams();
    }
  }, []);

  if (onPageLoad === "loading") return <Loading />;
  if (onPageLoad === "error") return <NotFound />;

  return (
    <Segment inverted textAlign="center" vertical className="masthead">
      {onPageLoad === "loading" && <Loading />}

      {onPageLoad === "success" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setOnPageLoad(onPageLoad)}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <SuccessSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Payment Successful</p>
            </div>

            {/* <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/")}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div> */}
          </div>
        </Modal>
      )}
      {onPageLoad === "failure" && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setOnPageLoad(onPageLoad)}
        >
          <div className={styles.verifyAccountModal}>
            {/* <h2>Activate Selling Permission</h2> */}

            <div className={styles.info}>
              {" "}
              <FailureSvg />
            </div>
            <div className={styles.welcomeText}>
              <p>Payment Unsuccessful</p>
            </div>

            {/* <div className={styles.twoButton}>
              <Button
                positive
                className={styles.modalactivate}
                onClick={() => navigate("/")}
              >
                <div className={styles.button}>
                  <span>Okay!</span>
                </div>
              </Button>
            </div> */}
          </div>
        </Modal>
      )}
    </Segment>
  );
};

export default observer(CallbackPage);
